import * as React from "react"
import { List } from "immutable"
import { Jumbo } from "../../../components/jumbo"
import { Block, BlockRenderer } from "../../../components/block_renderer"
import { errorText, noResultsText } from "../../../../custom_api/api"
import { Link } from "../../../components/library/link"
import { TeaserHasLinkContent } from '../../../components/teaser'
import { Loader } from "../../../components/loader"
import { capacityOptions, RoomFilter } from "../../../components/room_filter"
import { SearchBarWrapper } from "../../../components/search_bar"
import { getDrupalRooms } from "./location_overview_page.utils"
import { CombinedLocation, RoomFilters } from "./location_overview_page.types"
import { ApiResult } from "../../../../../Shared/api/apiTypes"
import { BasePageProps } from "../../../components/page_renderer"

export interface LocationOverviewPageProps extends BasePageProps {
  readonly kind: "locationOverviewContent"
  readonly pageTitle: string
  readonly headerTitle: string
  readonly description: string
  readonly buttonUrl: string
  readonly buttonTitle: string
  readonly imageUrl: string
  readonly imageUrlLarge: string
  readonly phImageUrlSmall?: string
  readonly phImageUrl: string
  readonly phImageUrlLarge: string
  readonly imageAlt: string
  readonly blocks: List<Block>
  readonly jumboSize: "small" | "large"
}

interface LocationOverviewPageState {
  drupalOvaticLocations: ApiResult<List<CombinedLocation>>

  filter: RoomFilters
}

export class LocationOverviewPage extends React.Component<LocationOverviewPageProps, LocationOverviewPageState> {
  constructor(props) {
    super(props)

    this.state = {
      drupalOvaticLocations: "loading",
      filter: {
        selectedCapacityOptionLabel: "",
        selectedEventType: "",
      }
    }
  }

  async componentDidMount() {
    document.title = this.props.pageTitle

    this.setState({
      drupalOvaticLocations: await getDrupalRooms()
    })
  }

  renderLocationOverview(drupalOvaticLocations: ApiResult<List<CombinedLocation>>) {
    if (drupalOvaticLocations == "loading") return <Loader />
    if (drupalOvaticLocations == "error") return null

    if (drupalOvaticLocations.size == 0) {
      return (
        <div className="block block--activity-cluster container--lg align--center">
          <div className="container--m align--center text--styled">
            <p className="weight--bold container--s">{noResultsText}</p>
          </div>
        </div>
      )
    }

    let eventTypes = drupalOvaticLocations
      .flatMap(l => List(l.ovaticLocation.eventTypes))
      .map(t => t.trim())
      .sortBy(t => t.toLocaleLowerCase().replace(/[^a-z0-9]/g, ''))
      .toOrderedSet()

    const selectedCap = capacityOptions.get(this.state.filter.selectedCapacityOptionLabel);
    const minCap = selectedCap ? selectedCap.min : null
    const maxCap = selectedCap ? selectedCap.max : null

    const selectedType = this.state.filter.selectedEventType

    let filtered = drupalOvaticLocations
      .filter(val => !selectedCap ? true : minCap <= val.ovaticLocation.capacity && val.ovaticLocation.capacity <= maxCap)
      .filter(val => !selectedType ? true : val.ovaticLocation.eventTypes.findIndex(e => e == selectedType) != -1)

    return (
      <>
        <SearchBarWrapper>
          <RoomFilter
            enabled={true}
            eventTypes={eventTypes}
            selectCapacity={selected => this.setState(prev => ({ filter: { ...prev.filter, selectedCapacityOptionLabel: selected } }))}
            selectEventType={selected => this.setState(prev => ({ filter: { ...prev.filter, selectedEventType: selected } }))}
            selectedCapacity={this.state.filter.selectedCapacityOptionLabel}
            selectedEventType={selectedType}
          />
        </SearchBarWrapper>

        <div className="block block--activity-cluster container--lg align--center">
          <ul className="teasers row">
            {filtered.map(room => this.renderLocationItem(room))}
          </ul>
        </div>
      </>
    )
  }

  renderLocationItem(room: CombinedLocation) {
    return <li key={`teaser-room-${room.ovatic_id}`} className="teaser teaser--haslink teaser--image col-xs-12 col-sm-6 col-md-4">
      <Link url={room.url} className="teaser__link">
        <TeaserHasLinkContent
          headingLevel={"h3"}
          title={room.title}
          imageUrl={room.image_url}
          imageAlt={room.image_alt}
          intro={room.description ? room.description : room.ovaticLocation.description}
          footer={"Meer informatie"}
        />
      </Link>
    </li>
  }

  render() {
    if (this.state.drupalOvaticLocations == "error") {
      return (
        <div className="zalenverhuur">
          <div className="block block--activity-cluster container--lg align--center">
            <div className="container--m align--center text--styled">
              <p className="weight--bold container--s">{errorText}</p>
            </div>
          </div>
        </div>
      )
    }

    return (
      <div className="zalenverhuur">
        <Jumbo
          title={this.props.headerTitle}
          contents={this.props.description}
          imageUrlSmall={this.props.jumboSize == 'small' && this.props.phImageUrlSmall ? this.props.phImageUrlSmall : undefined}
          imageUrl={this.props.phImageUrl}
          imageUrlLarge={this.props.phImageUrlLarge}
          imageAlt={this.props.imageAlt}
          buttonUrl={this.props.buttonUrl}
          buttonTitle={this.props.buttonTitle}
          size={this.props.jumboSize}
        />
        {this.renderLocationOverview(this.state.drupalOvaticLocations)}
        <BlockRenderer blocks={this.props.blocks} />
      </div>
    )
  }
}

{/* TH: Added to styleguide! */ }